import React from "react";
import DeviceQrScanner from "../mobile/DeviceQrScanner";

const QRScanner = ({ isOpen, onScanSuccess, onClose }) => {
  if (!isOpen) return null;
  return <DeviceQrScanner onScan={onScanSuccess} onClose={onClose} />;
};

export default QRScanner;
